export default {
      id: "Icon--settings-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--settings",
      toString: function () {
        return this.url;
      }
    }